// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__ZG8Sf","avatar":"style_avatar__mu3c4"};